import React, { useContext, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { AuthContext } from '../../../context/auth';

import Logout from '../../Logout';

import '../styles/Nav.css';
import '../../../Mobile.css';

// import imageLogo from '../../../assets/img/logoTopo2.png';
import imageLogo from '../../../assets/img/logoTopo3.png';
import fruitLogo from '../../../assets/img/fruitLogo.png';


const Nav = () => {
  const { loginUser } = useContext(AuthContext);
  const [avatarError, setAvatarError] = useState(false);

  const user = loginUser || {
    first_name: "Usuário",
    last_name: "Desconhecido",
    email: "",
    avatar: null,
    roles: ""
  }; // Default values

  // const initials = (user?.first_name ? user.first_name.charAt(0) : '') + (user?.last_name ? user.last_name.charAt(0) : '');
  const initials = `${user?.first_name?.[0] || ''}${user?.last_name?.[0] || ''}`;
  const fullName = `${user.first_name} ${user.last_name}`;
  const avatarUrl = user?.avatar;

  return (
    <>
      <div className="navbar">
        <div className='navbarBrand'>
          <NavLink className={'alonelink'} to="/home" key="home">
            <img className='imgLogo' src={imageLogo} alt="logo - brand" />
          </NavLink>
        </div>
        <div className='navbarCenter'>
          <div className="initials">
            {avatarUrl && !avatarError ? (
              <img
                src={avatarUrl}
                alt="Avatar"
                className="userAvatar"
                data-tip={fullName}
                onError={() => setAvatarError(true)}
              />
            ) : (
              <div
                className="userInitials"
                data-tip={fullName}
              >
                {initials}
              </div>
            )}
          </div>
          <div className="user-email">{user.email}</div>
          <div className="roles">{user.roles}</div>
        </div>
        <div className="navbarRight">
          <NavLink className={'alonelink'} to="/" key="logout">
            <Logout />
          </NavLink>
        </div>
      </div>

      <div id="mobileMenu">
        <div className={"nav-links"}>
          <div className="nav-item">
            <a href="/home">Home</a>
          </div>
          <div className="nav-item dropdown">
            <button className="dropbtn">Users</button>
            <div className="dropdown-content">
              <a href="/home/user/get">Todos os usuários</a>
            </div>
          </div>
          <div className="nav-item">
            <a href="/about">About</a>
          </div>
          <div className="nav-item">
            <a href="http://localhost:3000/">Login</a>
          </div>
          <div className="nav-item">
            <a href="http://localhost:3000/">Login</a>
          </div>
          <div className="nav-item">
            <a href="http://localhost:3000/">Login</a>
          </div>
          <div className="nav-item">
            <a href="http://localhost:3000/">Login</a>
          </div>
          <div className="nav-item">
            <a href="http://localhost:3000/">Login</a>
          </div>
          <div className="nav-item">
            <a href="http://localhost:3000/">Login</a>
          </div>
        </div>
      </div>

    </>

  );
};

export default Nav;
